// @flow

import React from 'react';
import Count from './count';
import { CheckboxContainer, Checkbox } from './checkboxFilter.styled';

type OwnProps = {|
  bucket: string,
  count?: number, // eslint-disable-line react/require-default-props
  label: string,
  label: string,
  onChange: Function,
  isSelected: boolean,
|};

type Props = OwnProps;

/* eslint jsx-a11y/label-has-for:
  [ 2, { "components": [ "Label" ], "required": { "every": [ "nesting", "id" ]},
  "allowChildren": true }] */

const CheckboxBucket = ({
  bucket,
  count,
  isSelected,
  onChange,
  label,
}: Props) => (
  <label htmlFor={bucket}>
    <CheckboxContainer>
      <div>
        <Checkbox
          error={false}
          name={bucket}
          checked={isSelected}
          onChange={onChange}
        />
        {label}
      </div>
      {count !== undefined && (
        <Count
          count={count}
        />
      )}
    </CheckboxContainer>
  </label>
);

export default CheckboxBucket;
